// extracted by mini-css-extract-plugin
export default {"card":"ChatRooms_card__Q7gay"};